import { MINERAL_ACTIONS } from './MINERAL_ACTIONS'

export function mineralReducer(state, action) {
  switch (action.type) {
    case MINERAL_ACTIONS.SET_MINERAL:
      return {
        ...state,
        mineral: action.payload.mineral,
      }
    case MINERAL_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}
